import React from 'react';

import { useSupplierLotRates } from '../api/getSupplierLotRates';
import { findCell, formatRate, formatRateRange } from '../utils/rates';
import { RateValueMatrices } from './RateValueMatrices';

export const LotRatesMatrices = ({ lotRates, isLoaded, onCellClick }) => {
  const getValue = (roleId, levelId) => {
    if (lotRates.rates_per_supplier) {
      const range = findCell(lotRates.ranges, roleId, levelId);
      return range && formatRateRange(range);
    }
    const rate = findCell(lotRates.rates, roleId, levelId);
    return rate && formatRate(rate.rate);
  };

  return (
    <RateValueMatrices
      structures={lotRates.level_structures}
      roles={lotRates.roles}
      isLoaded={isLoaded}
      exclusions={lotRates.exclusions}
      getValue={getValue}
      onCellClick={onCellClick}
    />
  );
};

export const SupplierRatesMatrices = ({ id, lotId, lotRates, facId }) => {
  const { data, isFetchedAfterMount } = useSupplierLotRates(id, lotId, facId);

  return (
    <RateValueMatrices
      structures={lotRates.level_structures}
      roles={lotRates.roles}
      isLoaded={isFetchedAfterMount}
      exclusions={data.exclusions}
      getValue={(roleId, levelId) => {
        const rate = findCell(data.rates, roleId, levelId);
        return rate && formatRate(rate.rate);
      }}
    />
  );
};
